import React from 'react';

interface StepCircleProps {
  stepNumber: number;
  status: 'completed' | 'pending' | 'qa-pass' | 'qa-fail' | 'ready-for-qa';
  size?: number;
  onClick?: () => void;
}

export const StepCircle: React.FC<StepCircleProps> = ({ stepNumber, status, size = 56, onClick }) => {
  const getCircleStyles = () => {
    switch (status) {
      case 'qa-pass':
        return {
          backgroundColor: 'var(--bs-success)',
          color: 'white',
          border: '2px solid var(--bs-success)',
        };
      case 'qa-fail':
        return {
          backgroundColor: 'var(--bs-danger)',
          color: 'white',
          border: '2px solid var(--bs-danger)',
        };
      case 'ready-for-qa':
      case 'completed':
        return {
          backgroundColor: 'white',
          color: 'var(--bs-success)',
          border: '2px solid var(--bs-success)',
        };
      case 'pending':
      default:
        return {
          backgroundColor: 'white',
          color: 'var(--bs-secondary)',
          border: '2px solid var(--bs-border-color)',
        };
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center rounded-circle fw-bold"
      onClick={onClick}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        fontSize: size > 50 ? '1rem' : '1.3rem',
        cursor: onClick ? 'pointer' : 'default',
        ...getCircleStyles(),
      }}
    >
      {stepNumber}
    </div>
  );
};
